"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _common = require("../common");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'other',
  props: {
    cloneForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // ADD 模式用 form.isIntegralExchange，回显模式用 couponIsIntegral
    isIntegralMode: function isIntegralMode() {
      return this.form.isIntegralExchange === 1 || this.couponIsIntegral;
    }
  },
  watch: {
    form: {
      handler: function handler(newVal, oldVal) {
        this.$emit('formChange', newVal);
      },
      deep: true
    },
    cloneForm: {
      handler: function handler(newForm) {
        var _this = this;
        this.form = _objectSpread(_objectSpread({}, this.form), newForm);

        // ADD 模式：isIntegralExchange 已由 changeCoupon 写入 form，直接同步到独立标识
        if (newForm.isIntegralExchange != null) {
          this.couponIsIntegral = newForm.isIntegralExchange === 1;
        }
        this.$nextTick(function () {
          if (_this.isIntegralMode) {
            _this.selectAllCustomers();
          } else {
            var _this$form$customerId;
            _this.form.customerId && _common.comData.customersList && _this.showCustomersList((_this$form$customerId = _this.form.customerId) === null || _this$form$customerId === void 0 ? void 0 : _this$form$customerId.split(',').map(function (j) {
              return Number(j);
            }));
          }
        });
      }
    },
    // 分销商列表异步加载完成后，若已是积分兑换券则补充全选
    'comData.customersList': {
      handler: function handler(list) {
        var _this2 = this;
        if (list && list.length > 0 && this.isIntegralMode) {
          this.$nextTick(function () {
            return _this2.selectAllCustomers();
          });
        }
      }
    }
  },
  data: function data() {
    return {
      formConfig: _common.formConfig,
      comData: _common.comData,
      rules: _common.rules,
      form: {
        labelId: [],
        channelIds: []
      },
      userType: null,
      // 独立保存积分兑换标识，不受 form 合并影响
      couponIsIntegral: false
    };
  },
  created: function created() {
    console.log(JSON.parse(_jsCookie.default.get('JavaInfo')).type, 'JavaInfo');
    this.userType = JSON.parse(_jsCookie.default.get('JavaInfo')).type;
  },
  methods: {
    validate: _common.validate,
    handleSelectionChange: function handleSelectionChange(list) {
      this.form.customerId = list.map(function (item) {
        return item.id;
      }).join(',');
    },
    rowSelectable: function rowSelectable() {
      return !this.isIntegralMode;
    },
    selectAllCustomers: function selectAllCustomers() {
      var tableRef = this.$refs.customersListTableRef;
      if (tableRef && _common.comData.customersList && _common.comData.customersList.length > 0) {
        _common.comData.customersList.forEach(function (row) {
          tableRef.toggleRowSelection(row, true);
        });
        // selectable 返回 false 时 selection-change 不会触发，直接赋值保证 customerId 提交正确
        this.form.customerId = _common.comData.customersList.map(function (item) {
          return item.id;
        }).join(',');
      }
    },
    /**
     * 回显分销授权列表
     */
    showCustomersList: function showCustomersList(ids) {
      var _this3 = this;
      _common.comData.customersList.forEach(function (item) {
        if (ids.includes(item.id)) {
          _this3.$refs.customersListTableRef.toggleRowSelection(item, true);
        }
      });
    }
  }
};